<template>
  <el-popover
    ref="popover"
    :placement="placement"
    :width="width"
    @show="onShow"
    @hide="onHide"
  >
    <Main
      ref="main"
      v-model="data"
      :funcListName="funcListName"
      :height="tableHeight"
    />
    <div class="d-flex justify-content-end mt-2">
      <el-button size="mini" type="text" @click="reset">
        {{ resetText }}
      </el-button>
      <el-button type="primary" size="mini" @click="confirm">
        {{ confirmText }}
      </el-button>
    </div>
    <template #reference>
      <slot name="reference">
        <vxe-button size="small" circle>
          <i class="el-icon-sort" style="font-size: 15px;" />
        </vxe-button>
      </slot>
    </template>
  </el-popover>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    value: { type: Array, required: true },
    funcListName: { type: String, required: true },
    placement: { type: String, default: 'bottom' },
    width: { type: Number, default: 280 },
    tableHeight: { type: Number, default: 250 },
    resetText: { type: String, default: '重置' },
    confirmText: { type: String, default: '确定' },
    resetOnConfirm: { type: Boolean, default: false },
    confirmOnClose: { type: Boolean, default: true },
  },
  data() {
    return { data: [], backdata: [] }
  },
  created() {
    this.data = JSON.parse(JSON.stringify(this.value))
  },
  methods: {
    onShow() {
      this.backdata = JSON.parse(JSON.stringify(this.data))
    },
    onHide() {
      this.data = JSON.parse(JSON.stringify(this.backdata))
    },
    reset() {
      this.$refs.main.setDefCheckbox()
      if (this.resetOnConfirm) {
        setTimeout(() => {
          this.confirm(false)
        }, 0)
      }
    },
    async confirm(isReset = true) {
      await new Promise((resolve) => {
        if (!this.data || !this.data.length) {
          if (isReset) this.reset()
        }
        setTimeout(() => {
          resolve()
        }, 0)
      })

      if (JSON.stringify(this.backdata) !== JSON.stringify(this.data)) {
        this.$emit('input', JSON.parse(JSON.stringify(this.data)))
        this.$emit('update:value', JSON.parse(JSON.stringify(this.data)))
        this.$emit('change', JSON.parse(JSON.stringify(this.data)))
      }

      this.$emit('confirm', JSON.parse(JSON.stringify(this.data)))

      this.onShow()
      if (this.confirmOnClose) {
        setTimeout(() => {
          this.$refs.popover.doClose()
        }, 0)
      }
    },
  },
}
</script>
